import { createViewConvert } from '../core/view/convert.js';
import { calendarViewModel } from './calendar/index.js';
import { ganttViewModel } from './gantt/index.js';
import { kanbanViewModel } from './kanban/index.js';
import { tableViewModel } from './table/index.js';

export const viewConverts = [
  createViewConvert(tableViewModel, kanbanViewModel, data => {
    if (data.groupBy) {
      return {
        filter: data.filter,
        groupBy: data.groupBy,
      };
    }
    return {
      filter: data.filter,
    };
  }),
  createViewConvert(kanbanViewModel, tableViewModel, data => ({
    filter: data.filter,
    groupBy: data.groupBy,
  })),
  createViewConvert(tableViewModel, ganttViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    zoomLevel: 'week' as const,
    snapMode: 'day' as const,
  })),
  createViewConvert(ganttViewModel, tableViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, width: 200, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header,
  })),
  createViewConvert(kanbanViewModel, ganttViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    zoomLevel: 'week' as const,
    snapMode: 'day' as const,
  })),
  createViewConvert(ganttViewModel, kanbanViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    header: {
      titleColumn: data.header?.titleColumn,
      iconColumn: data.header?.iconColumn,
    },
    groupProperties: data.groupProperties ?? [],
  })),
  createViewConvert(tableViewModel, calendarViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    calendarMode: 'week' as const,
  })),
  createViewConvert(calendarViewModel, tableViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, width: 200, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header,
  })),
  createViewConvert(ganttViewModel, calendarViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    startDateCol: data.startDateCol,
    endDateCol: data.endDateCol,
    statusCol: data.statusCol,
    attendeesCol: data.assigneeCol,
    calendarMode: 'week' as const,
  })),
  createViewConvert(calendarViewModel, ganttViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    sort: data.sort,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    startDateCol: data.startDateCol,
    endDateCol: data.endDateCol,
    statusCol: data.statusCol,
    assigneeCol: data.attendeesCol,
    zoomLevel: 'week' as const,
    snapMode: 'day' as const,
  })),
  createViewConvert(kanbanViewModel, calendarViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    groupProperties: data.groupProperties,
    header: data.header
      ? {
          titleColumn: data.header.titleColumn,
          iconColumn: data.header.iconColumn,
        }
      : undefined,
    calendarMode: 'week' as const,
  })),
  createViewConvert(calendarViewModel, kanbanViewModel, data => ({
    columns: data.columns.map(c => ({ id: c.id, hide: c.hide })),
    filter: data.filter,
    groupBy: data.groupBy,
    header: {
      titleColumn: data.header?.titleColumn,
      iconColumn: data.header?.iconColumn,
    },
    groupProperties: data.groupProperties ?? [],
  })),
];
